import React, { useEffect, useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table'

import { getMaintenancePlans } from '../../../api'

import styles from './styles.module.scss'

import Table from '../../Invoices/Table'

const columnHelper = createColumnHelper()

const MaintenancePlans = ({companyId, onClickPlan}) => {
  const { t } = useTranslation()

  const [plans, setPlans] = useState([])

  const triggerTitleMap = {
    specific_date: t('Specific date'),
    warranty_expiration: t('Warranty expiration'),
  }

  useEffect(() => {
    getPlans()
    const handler = (event) => {
      getPlans()
    }
    window.addEventListener('plan-updated', handler)
    return () => {
      window.removeEventListener('plan-updated', handler)
    }
  }, [])

  const getPlans = async () => {
    const res = await getMaintenancePlans(companyId)
    if (Array.isArray(res)) {
      setPlans(res)
    }
  }

  const columns = useMemo(() => [
    columnHelper.accessor('name', {
      enableSorting: false,
      header: t('Plan'),
    }),
    columnHelper.display({
      id: 'applies',
      enableSorting: false,
      header: t('Applies to'),
      cell: ({ row }) => {
        return (
          <div className={styles.appliesCell}>
            <div className={styles.badge}>{row.original.asset_id ? t('Asset') : t('Category')}</div>
            <div className={styles.appliesValue}>{ row.original.asset ? row.original.asset.name : (row.original.category ? row.original.category.name : '') }</div>
          </div>
        )
      }
    }),
    columnHelper.accessor('trigger', {
      enableSorting: false,
      header: t('Trigger'),
      cell: ({ row }) => {
        return triggerTitleMap[row.original.trigger] || row.original.trigger
      }
    }),
    columnHelper.display({
      id: 'repeat',
      enableSorting: false,
      header: t('Repeat'),
      cell: ({ row }) => {
        return row.original.schedule_type === 'recurring' ? t('every {{interval}} {{unit}}', { interval: row.original.interval_value, unit: row.original.interval_unit }) : t('One-time')
      }
    }),
    columnHelper.accessor('assets_count', {
      enableSorting: false,
      header: t('Assets Count'),
    }),
    columnHelper.accessor('estimated_cost', {
      enableSorting: false,
      header: t('Est. cost'),
    }),
  ], [t])

  const table = useReactTable({
    data: plans,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getRowId: row => String(row.id),
  })

  return (
    <div className={styles.container}>
      <Table table={table} columns={columns} headerClassName={styles.tableHeader} onClickRow={onClickPlan} />
    </div>
  )
}

export default MaintenancePlans
